import BesmartCondition from "../components/BesmartCondition.jsx";
import useBesmartcondition from "../hooks/useBeSmart.js";


function BesmartConditionPages() {
  const useBesmartProps = useBesmartcondition();
  return <BesmartCondition {...useBesmartProps} />;
}

export default BesmartConditionPages;
